var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReassginCsrep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 28C30.7614 28 33 25.7614 33 23C33 20.2386 30.7614 18 28 18C25.2386 18 23 20.2386 23 23C23 25.7614 25.2386 28 28 28Z",
    stroke: "#0EA3FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2101 31.741L31.67 35.281C31.53 35.421 31.4 35.681 31.37 35.871L31.18 37.221C31.11 37.711 31.45 38.051 31.94 37.981L33.29 37.791C33.48 37.761 33.75 37.631 33.88 37.491L37.42 33.951C38.03 33.341 38.32 32.631 37.42 31.731C36.53 30.841 35.8201 31.131 35.2101 31.741Z",
    stroke: "#0EA3FD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7002 32.25C35.0002 33.33 35.8402 34.17 36.9202 34.47",
    stroke: "#0EA3FD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4099 38C19.4099 34.13 23.2599 31 27.9999 31C29.0399 31 30.0399 31.15 30.9699 31.43",
    stroke: "#0EA3FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F0F9FF",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReassginCsrep);
export default __webpack_public_path__ + "static/media/reassgin_csrep.25d222dab72f7a557484fa0638e61408.svg";
export { ForwardRef as ReactComponent };